import { render, staticRenderFns } from "./RoomComments.vue?vue&type=template&id=841f09c2&"
import script from "./RoomComments.vue?vue&type=script&lang=js&"
export * from "./RoomComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports